import { Injectable } from '@angular/core';
import { Apollo } from 'apollo-angular';
import { GET_CLIENT_IDIOM, GET_CLIENT_PERMISSION_QUERY, GET_ESTABLISHMENT_BY_ID, GET_INFO_CLIENT_RULE, GET_TEMP_URLS, GET_TUTORIALS, GET_USER_LANGUAGE, GET_USER_ROLE, SAVE_TUTORIALS } from './graphql/queries';
import { map } from 'rxjs/operators';

@Injectable()
export class InovaCommonGraphqlApi {
  constructor(private apollo: Apollo) { }

  getTempUrls(urls: string[], expirationTime = undefined) {
    return this.apollo.query<any>({ query: GET_TEMP_URLS, variables: { urls, expirationTime } }).pipe(
      map(x => {
        return x.data.getTempUrls
      }),
    )
  }

  getTutoriales() {
    return this.apollo.query<any>({ query: GET_TUTORIALS }).pipe(
      map(x => {
        return x.data.userTutoriales
      }),
    )
  }

  saveTutorials(id: any, tutorial: string) {
    const variables = { id, tutorial };
    return this.apollo.mutate({ mutation: SAVE_TUTORIALS, variables: { input: { ...variables } } });
  }

  getClientServices(){
    return this.apollo.watchQuery<any>({query: GET_CLIENT_PERMISSION_QUERY}).valueChanges.pipe(
      map(response => response.data.servicios.edges.map((x:any) => x.node)));
  }

  getUserRole(){
    return this.apollo.query<any>({query: GET_USER_ROLE}).pipe(map(response => response.data.currentUser));
  }

  getUserLanguage() {
    return this.apollo.query<any>({query: GET_USER_LANGUAGE}).pipe(map(response => response.data.lenguajeCliente));
  };

  getClientLanguage() {
    return this.apollo.query<any>({query: GET_CLIENT_IDIOM}).pipe(map(response => response.data.clientes.edges[0].node));
  };

  getEntityById(id:string){
    return this.apollo.query<any>({ query: GET_ESTABLISHMENT_BY_ID, variables: {id} }).pipe(map(response => {
      const entity=response.data.entidad;
      try {
        entity.informacionGeneral=JSON.parse(entity.informacionGeneral);
      } catch (error) {}
      return entity;
    }));
  }

  getClientInfoRule(){
    return this.apollo.query<any>({query: GET_INFO_CLIENT_RULE}).pipe(
      map(x => {
        try {
          const rule=x.data.normas.edges.map((y:any)=>y.node)[0];
          rule.metadata=JSON.parse(rule.metadata);
          return rule;
        }
        catch (error) { }
        return null
      }),
    )
  }


}
